import {isRtl} from 'scratch-l10n';
import editorMessages from 'scratch-l10n/locales/editor-msgs';

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

const ikoosMessageOverrides = {
    'gui.alerts.lostPeripheralConnection': 'IKOOS lost connection to {extensionName}.',
    'gui.connection.auto-scanning.updatePeripheralPrompt':
        'If you don\'t see your device, you may need to update it to work with IKOOS.',
    'gui.connection.scanning.updatePeripheralPrompt':
        'If you don\'t see your device, you may need to update it to work with IKOOS.',
    'gui.connection.unavailable.installscratchlink': 'Make sure you have IKOOS Link installed and running',
    'gui.connection.updatePeripheral.doNotDisconnect':
        'Do not leave or reload IKOOS or disconnect your {extensionName} until the update is complete.',
    'gui.crashMessage.description':
        'We are so sorry, but it looks like IKOOS has crashed. This bug has been automatically reported to ' +
        'the IKOOS Team. Please refresh your page to try again.',
    'gui.accountMenu.ikoosChangePassword': 'Ubah Password',
    'gui.accountMenu.ikoosProjects': 'Project Saya',
    'gui.accountMenu.profile': 'Profile',
    'gui.accountMenu.signOut': 'Sign Out',
    'gui.alerts.createsuccess': 'Project berhasil disimpan.',
    'gui.alerts.creating': 'Menyimpan project...',
    'gui.alerts.creatingError': 'Project belum bisa disimpan. Silakan coba lagi.',
    'gui.alerts.download': 'Unduh',
    'gui.alerts.savesuccess': 'Project berhasil disimpan.',
    'gui.alerts.saving': 'Menyimpan project...',
    'gui.alerts.savingError': 'Project belum bisa disimpan.',
    'gui.alerts.tryAgain': 'Coba lagi',
    'gui.gui.defaultProjectTitle': 'IKOOS Project',
    'gui.menuBar.joinScratch': 'Join IKOOS',
    'gui.menuBar.saveNow': 'Simpan project',
    'gui.menuBar.saveNowLink': 'Simpan project',
    'gui.spriteSelector.addSpriteFromLibrary': 'Pilih Sprite',
    'gui.telemetryOptIn.body1':
        'The IKOOS Team is always looking to better understand how IKOOS is used around the world. To help ' +
        'support this effort, you can allow IKOOS to automatically send usage information to the IKOOS Team.',
    'gui.telemetryOptIn.label': 'Report statistics to improve IKOOS',
    'gui.telemetryOptIn.optInText': 'Share my usage data with the IKOOS Team',
    'gui.telemetryOptIn.optOutText': 'Do not share my usage data with the IKOOS Team',
    'gui.unsupportedBrowser.description':
        'We are very sorry, but IKOOS does not support this browser. We recommend updating to the latest ' +
        'version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.',
    'gui.unsupportedBrowser.notRecommended':
        'We are very sorry, but it looks like you are using a browser version that IKOOS does not support. We ' +
        'recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, ' +
        'Microsoft Edge, or Apple Safari.',
    'gui.webglModal.description':
        'Unfortunately it looks like your browser or computer <a>{webGlLink}</a>. This technology is needed ' +
        'for IKOOS to run.'
};

const withIkoosMessageOverrides = messages => Object.assign({}, messages || {}, ikoosMessageOverrides);

const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale: editorMessages,
    messages: withIkoosMessageOverrides(editorMessages.en)
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_LOCALE:
        return Object.assign({}, state, {
            isRtl: isRtl(action.locale),
            locale: action.locale,
            messagesByLocale: state.messagesByLocale,
            messages: withIkoosMessageOverrides(state.messagesByLocale[action.locale])
        });
    case UPDATE_LOCALES:
        return Object.assign({}, state, {
            isRtl: state.isRtl,
            locale: state.locale,
            messagesByLocale: action.messagesByLocale,
            messages: withIkoosMessageOverrides(action.messagesByLocale[state.locale])
        });
    default:
        return state;
    }
};

const selectLocale = function (locale) {
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (Object.prototype.hasOwnProperty.call(currentState.messagesByLocale, locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: isRtl(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: withIkoosMessageOverrides(currentState.messagesByLocale[locale])
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
